import { type QuizType } from '@/views/build/components/type';

import manifest from './quizTypePreviewManifest.json';

/** 실제 풀이 모달 폭(QuizModalDialog `mobile-lg:!max-w-[520px]`) */
export const QUIZ_TYPE_PREVIEW_CAPTURE_WIDTH = 520;

/** 목록은 `_scripts/capture-quiz-type-preview.mjs` 가 쓴다. 나간 영상은 `--bump` 로 버전을 올려 새 주소로 바꾼다 */
const VIDEO_DIR = '/assets/quiz-type-preview';
const CAPTURED: Partial<Record<string, Partial<Record<string, number>>>> =
  manifest.videos;

const FALLBACK_LOCALES = ['en', 'ko'];

export const getQuizTypePreviewVideo = (
  type: QuizType,
  language: string,
): string | undefined => {
  for (const locale of [language, ...FALLBACK_LOCALES]) {
    const version = CAPTURED[locale]?.[type];
    if (version !== undefined) {
      return `${VIDEO_DIR}/${locale}/${type}.v${version}.mp4`;
    }
  }
  return undefined;
};
